import { useQuery } from '@tanstack/react-query';
import { apiFetch } from '../api/client';
import type { RangeCredentials } from '../api/types';

/**
 * useRangeCredentials — GET /ranges/{rangeId}/credentials (Phase C). Returns the
 * credentials the caller may see (scenario app creds + OS login), RBAC-filtered
 * server-side: trainees get only their assigned VMs + trainee_visible entries.
 * Used by the console Range Info > Machines tab.
 */
export function useRangeCredentials(rangeId: string | undefined, enabled = true) {
  return useQuery<RangeCredentials>({
    queryKey: ['range-credentials', rangeId ?? ''],
    enabled: enabled && Boolean(rangeId),
    staleTime: 60_000,
    queryFn: async ({ signal }) =>
      apiFetch<RangeCredentials>('/ranges/{rangeId}/credentials', {
        method: 'GET',
        pathParams: { rangeId: rangeId ?? '' },
        signal,
      }),
  });
}
